/**
 * Lazy loader for the Square Web Payments SDK.
 * In mock mode (returned by /api/payments/sdk-config) we don't load the SDK.
 * Returns: { Payments, applicationId, locationId } or null if disabled / failed.
 */
let _loadPromise = null;

export async function loadSquarePayments({ applicationId, locationId, mode }) {
  if (mode !== "sandbox" && mode !== "live") return null;
  if (!applicationId || !locationId) return null;

  if (_loadPromise) return _loadPromise;
  _loadPromise = new Promise((resolve, reject) => {
    if (window.Square) return resolve(window.Square);
    const src = mode === "live"
      ? "https://web.squarecdn.com/v1/square.js"
      : "https://sandbox.web.squarecdn.com/v1/square.js";
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    s.onload = () => resolve(window.Square);
    s.onerror = () => reject(new Error("Failed to load Square Web Payments SDK"));
    document.head.appendChild(s);
  });

  try {
    const Square = await _loadPromise;
    const payments = Square.payments(applicationId, locationId);
    return { payments, applicationId, locationId };
  } catch (e) {
    _loadPromise = null;
    throw e;
  }
}
